// Maps x0..x1 range into y0..y1 range for any given x
// E.g. linear(0, 10, 2, 6, 5) === 4
// Reverse order for Y range is also supported:
//   linear(0, 10, 50, 10, 5) === 30
export const linearScale = (x0: number, x1: number, y0: number, y1: number, xValue: number) => {
  if (xValue < x0) {
    return y0;
  } else if (xValue > x1) {
    return y1;
  }
  return y0 + ((y1 - y0) * (xValue - x0)) / (x1 - x0);
};
